import {feedbackSespelUrl} from './solution/solutionUrl';
import {checkToken} from './solution/solutionToken';
export const MAX_RESUME_SIZE = 10 * 1024 * 1024;

export function fetchRequestVacancies(signal) {
    const requestOptions = {
        method: 'GET',
        headers: {Accept: '*/*'},
        redirect: 'follow',
        signal,
    };
    return fetch(`${feedbackSespelUrl}/vacancies-open`, requestOptions)
        .then(response => checkToken(response))
        .then(data => {
            const list = Array.isArray(data) ? data : data?.vacancies ?? data?.data;
            if (!Array.isArray(list)) throw new Error('Не удалось прочитать список вакансий. Попробуйте позже.');
            return list.filter(item => item
                && item.id != null
                && typeof item.title === 'string'
                && (item.is_active === undefined || item.is_active === true
                    || item.is_active === 1 || item.is_active === 'true'));
        });
}

export function validateResume(file) {
    if (!file) return 'Прикрепите резюме.';
    if (!/\.(pdf|doc|docx)$/i.test(file.name)) return 'Разрешены только PDF, DOC и DOCX.';
    if (file.size === 0) return 'Файл пуст. Выберите другой файл.';
    if (file.size > MAX_RESUME_SIZE) return 'Размер резюме не должен превышать 10 МБ.';
    return '';
}

export function resumeToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result).split(',')[1]);
        reader.onerror = () => reject(new Error('Не удалось прочитать файл. Прикрепите его ещё раз.'));
        reader.onabort = () => reject(new Error('Чтение файла прервано.'));
        reader.readAsDataURL(file);
    });
}

export function fetchRequestAddVacancyResponse(payload, signal) {
    const requestOptions = {
        method: 'POST',
        headers: {Accept: '*/*', 'Content-Type': 'application/json'},
        body: JSON.stringify({
            vacancy_id: payload.vacancy_id,
            full_name: payload.full_name,
            phone: payload.phone,
            email: payload.email,
            file_base64: payload.file_base64,
            file_name: payload.file_name,
            cover_letter: payload.cover_letter,
        }),
        redirect: 'follow', signal,
    };
    return fetch(`${feedbackSespelUrl}/responses`, requestOptions)
        .then(response => checkToken(response));
}

export function salaryLabel(vacancy, english = false) {
    const format = value => Number(value).toLocaleString(english ? 'en-GB' : 'ru-RU');
    const min = Number(vacancy.salary_min), max = Number(vacancy.salary_max);
    const hasMin = Number.isFinite(min) && min > 0, hasMax = Number.isFinite(max) && max > 0;
    if (hasMin && hasMax) return min === max ? `${format(min)} ₽` : `${format(min)}–${format(max)} ₽`;
    if (hasMin) return `${english ? "from" : "от"} ${format(min)} ₽`;
    if (hasMax) return `${english ? "up to" : "до"} ${format(max)} ₽`;
    return english ? 'Negotiable' : 'По договорённости';
}
